module.exports = __webpack_public_path__ + "images/0196d0a0797f35ed8bd72eb0de665264-reno Tahoe.png";